import { styled } from "@mui/material/styles";
import List from "@mui/material/List";

export type NAV = { label: string; value: string };
export const accountMenuData: Array<NAV> = [];
export const FireNav = styled(List)({
  "& .MuiListItemButton-root": {
    paddingLeft: 24,
    paddingRight: 24,
  },
  "& .MuiListItemIcon-root": {
    minWidth: 0,
    marginRight: 16,
  },
  "& .MuiSvgIcon-root": {
    fontSize: 20,
  },
});
